import React, {Component} from 'react';
import './AuthPasswordScreen.css';
import ArrowLink from "../Common/ArrowLink";
import RmField from "../Forms/RmField";
import RmButton from "../Common/RmButton";
import AuthScreen from "./AuthScreen";
import axios from 'axios';
import ErrorMessage from "../Common/ErrorMessage";

export default class AuthPasswordScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            attemptingReset: false,
            email: "",
            errorMessage: null,
            redirecting: false,
            isComplete: false
        };
    }

    handleButtonClick() {
        if (this.state.attemptingReset) {
            return;
        }

        this.submitPasswordReset(this.state.email);
    }

    handleEmailChange(value) {
        this.setState({
            email: value,
            errorMessage: null
        });
    }

    submitPasswordReset() {
        this.setState({
            attemptingReset: true,
            errorMessage: null
        });

        let payload = {
            email: this.state.email,
            password: this.state.password
        };

        axios.post("/password_reset", payload)
            .then((res) => {
                let data = res.data;

                if (data.ok) {
                    this.setState({
                        isComplete: true
                    });
                } else {
                    this.setState({
                        errorMessage: data.message || "Controleer de ingevoerde gegegevens."
                    });
                }
            })
            .catch((err) => {
                console.error('Password reset failure caught:', err);

                this.setState({
                    errorMessage: "Er ging iets mis bij het verwerken van je verzoek. Probeer het opnieuw."
                });
            })
            .then(() => {
                this.setState({
                    attemptingReset: false
                });
            });
    }

    render() {
        return (
            <AuthScreen title={"Wachtwoord vergeten"}>
                {!this.state.isComplete &&
                <div>
                    <p className={"AuthPasswordScreen__intro"}>
                        U kunt een nieuw wachtwoord instellen voor uw planning tools account via een e-mail bericht.
                    </p>

                    <div>
                        <RmField id={"email"} label={"Vul hier uw e-mail adres in..."} iconName={"email-outline"}
                                 inputType={"email"} disabled={!!this.state.attemptingReset}
                                 value={this.state.email} onChange={this.handleEmailChange.bind(this)}
                        />
                    </div>

                    {this.state.errorMessage &&
                    <ErrorMessage message={this.state.errorMessage}/>
                    }

                    <div className={"AuthPasswordScreen__submit"}>
                        <RmButton label={"Doorgaan"} busy={!!this.state.attemptingReset}
                                  onClick={this.handleButtonClick.bind(this)}/>
                    </div>
                </div>
                }

                {this.state.isComplete &&
                <p className={"AuthPasswordScreen__intro"}>
                    <strong>We hebben een e-mail met instructies verzonden naar het opgegeven e-mail adres.</strong>
                </p>
                }

                <hr className={"AuthPasswordScreen__sep"}/>

                <div className={"AuthPasswordScreen__extras"}>
                    <ArrowLink label={"Terug naar inlogscherm"} href={"/inloggen"}/>
                    <ArrowLink label={"Aanmelden voor nieuw account"} href={"/aanmelden"}/>
                </div>
            </AuthScreen>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Auth/AuthPasswordScreen.js